export default __webpack_public_path__ + "static/media/discord.7f6d5ea1.svg";